import { useRouter } from 'next/router';

const useRedirectToBookPage = (type: string) => {
  const router = useRouter();
  const url = router?.asPath;
  const splitedUrl = url.split('/read')[0];

  if (type !== 'book') {
    typeof window !== 'undefined' && router.push(splitedUrl);
  }
};

export default useRedirectToBookPage;
